import tw from 'twin.macro';

export const ChatContainer = tw.div`w-full h-full mx-auto lg:max-w-xl bg-background-light`;
export const HeaderShadow = tw.div`shadow-[0_0_16px_rgba(0, 0, 0, 0.15)]`;
